export default __webpack_public_path__ + "static/boguszewska-07143ba7c473a1d3c76305b03bbbffe7.jpg";